<div class="panel-shadow"></div>
<div class="panel-content">
    <ng-content select="app-panel-header"></ng-content>
    <div class="panel-body">
        <ng-content></ng-content>
    </div>
</div>